import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterFilterInterface } from 'modules/newsletters/single/types/newsletter-filter-interface'
import { NewsletterApiInterface } from 'modules/newsletters/single/types/newsletter-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

interface UseNewslettersInterface extends SwrPaginationInterface {
  filter: NewsletterFilterInterface
}

export function useNewsLetters({ limit, pagination, filter }: UseNewslettersInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, NewsletterApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${
    filter.search !== '' ? `&filter[searchBy]=${encodeURIComponent(filter.search)}` : ''
  }`

  const { data: newsletters, mutate } = useSWR(
    () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${NEWSLETTERS_API}/list?pagination[limit]=${limit}${filterApi}`
      } else if (user && pagination.startFromId && limit) {
        return `${NEWSLETTERS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`
      }
      return null
    },
    fetcher,
    { revalidateIfStale: true },
  )

  const { data: counter } = useSWR<CountInterface>(() => {
    if (user) {
      return `${NEWSLETTERS_API}/count?pagination[limit]${filterApi}`
    }
    return null
  }, baseFetcher)

  return { newsletters, mutate, counter }
}
